import { useMemo } from 'react'
import { Position, Rect } from 'types'
import { Container, Dim } from './style'

type Props = {
    bounds: Rect
    className?: string
    crop: Position
}

const CropDim = ({ bounds, className, crop }: Props) => {
    const topStyle = useMemo(
        () => ({
            height: crop.y,
            left: 0,
            top: 0,
            width: `100%`,
        }),
        [crop.y]
    )

    const bottomStyle = useMemo(
        () => ({
            bottom: 0,
            height: bounds.bottom - (crop.y + crop.height),
            left: 0,
            width: `100%`,
        }),
        [bounds.bottom, crop.height, crop.y]
    )

    const leftStyle = useMemo(
        () => ({
            height: crop.height,
            left: 0,
            top: crop.y,
            width: crop.x,
        }),
        [crop.height, crop.x, crop.y]
    )

    const rightStyle = useMemo(
        () => ({
            height: crop.height,
            right: 0,
            top: crop.y,
            width: bounds.right - (crop.x + crop.width),
        }),
        [bounds.right, crop.height, crop.width, crop.x, crop.y]
    )

    return (
        <Container className={className}>
            <Dim style={topStyle} />
            <Dim style={leftStyle} />
            <Dim style={rightStyle} />
            <Dim style={bottomStyle} />
        </Container>
    )
}

export default CropDim
